import axios from '../../axios'
import Axios from 'axios'
import { Upload, Progress } from '@aws-sdk/lib-storage'
import { cognitoConfig } from 'config'
import {getS3Client} from './S3Client'

const region = cognitoConfig.aws_cognito_region
const COGNITO_ID = `cognito-idp.${region}.amazonaws.com/${cognitoConfig.aws_user_pools_id}`
const S3_BUCKET = cognitoConfig.temp_s3_bucket
const MULTIPART_LIMIT = 1024 * 1024 * 50 // 50 MB

const getUserId = async () => {
  return await axios(`/api/v1/user/current`).then(({ data }: any) => data.id)
}

export const uploadFile = async (
  file: File,
  getUploadUrl: (type: string) => Promise<string>,
  onProgress: (progress: Progress) => void
): Promise<string> => {
  // If file size is greater then the limit, then we need to upload the file using the multipart upload
  // otherwise we can upload the file using simple upload
  if (file.size >= MULTIPART_LIMIT) {
    const userId = await getUserId()
    const target = {
      Bucket: S3_BUCKET,
      Key: `${userId}/${file.name}`,
      Body: file,
    }
    const client = await getS3Client()
    const parallelUploads3 = new Upload({
      client,
      leavePartsOnError: false, // optional manually handle dropped parts
      partSize: 1024 * 1024 * 10, // 10 MB
      params: target,
    })
    parallelUploads3.on('httpUploadProgress', onProgress)
    await parallelUploads3.done()

    return `https://${target.Bucket}.s3.${region}.amazonaws.com/${target.Key}`
  } else {
    const extension = file.name.split('.').pop() || ''
    const signedUrl = await getUploadUrl(extension)
    await Axios.create().put(signedUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
      onUploadProgress: onProgress,
    })
    return signedUrl
  }
}

export default {
  uploadFile
}
